import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import N2NService from "./n2nService";
import { RootState } from "../../app/store";
import MembersService from "../members/membersService";
import n2nService from "./n2nService";

interface N2NActivation {
  fetchNetworks: {
    networksListData: any | null;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchRoles: {
    rolesListData: any | null;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchSpecialties: {
    specialtyListData: any | null;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchUsers: {
    usersListData: any | null;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  fetchN2NDetails: {
    n2nDetailsData: any | null;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
  activateN2N: {
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
    message: string;
  };
}

const initialState: N2NActivation = {
fetchNetworks: {
    networksListData: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchRoles: {
    rolesListData: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchSpecialties: {
    specialtyListData: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchUsers: {
    usersListData: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  fetchN2NDetails: {
    n2nDetailsData: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  },
  activateN2N: {
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
  }
};

export const fetchNetworks = createAsyncThunk("n2nActivation/fetchNetworks", async (payload:any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user && state.auth.user.token;

    const response = await n2nService.fetchNetworksList(payload, token);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchRoles = createAsyncThunk("n2nActivation/fetchRoles", async (payload:any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user && state.auth.user.token;

    const response = await N2NService.fetchRoleList(payload, token);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchSpecilialtyList = createAsyncThunk("n2nActivation/fetchSpecilialtyList", async (payload:any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user && state.auth.user.token;

    const response = await N2NService.fetchSpecilialtyList(payload, token);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchusers = createAsyncThunk("n2nActivation/fetchusers", async (payload:any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user && state.auth.user.token;

    const response = await N2NService.fetchUsersList(payload, token);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const fetchN2NDetails = createAsyncThunk("n2nActivation/fetchN2NDetails", async (payload, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user && state.auth.user.token;

    const response = await N2NService.fetchN2NDetials(payload, token);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const activiateN2N = createAsyncThunk("n2nActivation/activiateN2N", async (payload:any, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as RootState;
    const token = state.auth.user && state.auth.user.token;

    const response = await N2NService.activateN2N(payload, token);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const n2nActivationSlice = createSlice({
  name: "n2nActivation",
  initialState,
  reducers: {
    resetFetchNetworks: (state) => {
      state.fetchNetworks = initialState.fetchNetworks
    },
    resetFetchRoles: (state) => {
      state.fetchRoles = initialState.fetchRoles
    },
    resetFetchSpecialy: (state) => {
      state.fetchSpecialties = initialState.fetchSpecialties;
    },
    resetfetchUsers: (state) => {
      state.fetchUsers = initialState.fetchUsers;
    },
    resetfetchN2NDetails: (state) => {
      state.fetchN2NDetails = initialState.fetchN2NDetails;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNetworks.pending, (state, action: PayloadAction<any>) => {
        state.fetchNetworks.isLoading = true;
      })
      .addCase(fetchNetworks.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchNetworks.isLoading = false;
        state.fetchNetworks.isSuccess = true;
        state.fetchNetworks.networksListData = action.payload;
      })
      .addCase(fetchNetworks.rejected, (state, action: PayloadAction<any>) => {
        state.fetchNetworks.isLoading = false;
        state.fetchNetworks.isError = true;
        state.fetchNetworks.message = action.payload;
        state.fetchNetworks.networksListData = null;
      })
      .addCase(fetchRoles.pending, (state, action: PayloadAction<any>) => {
        state.fetchRoles.isLoading = true;
      })
      .addCase(fetchRoles.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchRoles.isLoading = false;
        state.fetchRoles.isSuccess = true;
        state.fetchRoles.rolesListData = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action: PayloadAction<any>) => {
        state.fetchRoles.isLoading = false;
        state.fetchRoles.isError = true;
        state.fetchRoles.message = action.payload;
        state.fetchRoles.rolesListData = null;
      })
      .addCase(fetchSpecilialtyList.pending, (state, action: PayloadAction<any>) => {
        state.fetchSpecialties.isLoading = true;
      })
      .addCase(fetchSpecilialtyList.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchSpecialties.isLoading = false;
        state.fetchSpecialties.isSuccess = true;
        state.fetchSpecialties.specialtyListData = action.payload;
      })
      .addCase(fetchSpecilialtyList.rejected, (state, action: PayloadAction<any>) => {
        state.fetchSpecialties.isLoading = false;
        state.fetchSpecialties.isError = true;
        state.fetchSpecialties.message = action.payload;
        state.fetchSpecialties.specialtyListData = null;
      })
      .addCase(fetchusers.pending, (state, action: PayloadAction<any>) => {
        state.fetchUsers.isLoading = true;
      })
      .addCase(fetchusers.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchUsers.isLoading = false;
        state.fetchUsers.isSuccess = true;
        state.fetchUsers.usersListData = action.payload;
      })
      .addCase(fetchusers.rejected, (state, action: PayloadAction<any>) => {
        state.fetchUsers.isLoading = false;
        state.fetchUsers.isError = true;
        state.fetchUsers.message = action.payload;
        state.fetchUsers.usersListData = null;
      })
      .addCase(fetchN2NDetails.pending, (state, action: PayloadAction<any>) => {
        state.fetchN2NDetails.isLoading = true;
      })
      .addCase(fetchN2NDetails.fulfilled, (state, action: PayloadAction<any>) => {
        state.fetchN2NDetails.isLoading = false;
        state.fetchN2NDetails.isSuccess = true;
        state.fetchN2NDetails.n2nDetailsData = action.payload;
      })
      .addCase(fetchN2NDetails.rejected, (state, action: PayloadAction<any>) => {
        state.fetchN2NDetails.isLoading = false;
        state.fetchN2NDetails.isError = true;
        state.fetchN2NDetails.message = action.payload;
        state.fetchN2NDetails.n2nDetailsData = null;
      })
      .addCase(activiateN2N.pending, (state, action: PayloadAction<any>) => {
        state.activateN2N.isLoading = true;
      })
      .addCase(activiateN2N.fulfilled, (state, action: PayloadAction<any>) => {
        state.activateN2N.isLoading = false;
        state.activateN2N.isSuccess = true;
      })
      .addCase(activiateN2N.rejected, (state, action: PayloadAction<any>) => {
        state.activateN2N.isLoading = false;
        state.activateN2N.isError = true;
        state.activateN2N.message = action.payload;
      })
      
  },
});

export const { resetFetchNetworks, resetFetchRoles, resetFetchSpecialy, resetfetchUsers } = n2nActivationSlice.actions;
export default n2nActivationSlice.reducer;